import { KeyboardEvent } from 'react';

const ENTER_KEY = 'Enter';

export const isEnter = (event: KeyboardEvent): boolean => {
  return event.key === ENTER_KEY && !event.shiftKey;
};

export const isCtrlEnter = (event: KeyboardEvent): boolean => {
  return event.key === ENTER_KEY && event.ctrlKey;
};

export const isMetaEnter = (event: KeyboardEvent): boolean => {
  return event.key === ENTER_KEY && event.metaKey;
};
